import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { AppConsts } from '../models/app-consts';
import { serviceConstants } from 'src/app/constants/service.constants';

@Injectable({
  providedIn: 'root'
})
export class ApidataRequestService {

  constructor(private http: HttpClient) { }

  InsertDataPost(url: string, formData: any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url), formData, this.getHeaders())
  }
//AppConsts.ApiServiceBaseUrl
  UpdateDataPost(url: string, formData: any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url), formData, this.getHeaders());
  }
  getData(url: string): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), this.getHeaders())
  }

  getuserlist(url: string): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), this.getHeaders())
  }

  
  getDataPost(url: string, formData: any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url), formData, this.getHeaders())
  }
  getDataByID(url: string): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), this.getHeaders())
  }
  updateDataByID(url: string): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), this.getHeaders())
  }
  getToken(url: string, formData: any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url), formData, this.getHeaders())
  }
  filePost(url: string, formData: any): Observable<any> {
    return this.http.post((serviceConstants.apiURL + url), formData, this.getHeaders())
  }

  getHeaders(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true
    };
    return httpOptions;
  }

  getFileHeaders(): any {
    const httpOptions = {
      headers: new HttpHeaders({
      }),
      withCredentials: true
    };
  }

  httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    }),
    withCredentials: true
}; 
}

export interface DateTimeRange {
  Day: number;
  Month: number;
  Year: number;
  Hours: number;
  Minutes: number;
  Seconds: number;
  IsEndDate?: boolean;
  HasValue?: boolean;
  IsDateModified?: boolean;
}

export interface DateTimes {
  Day: number;
  Month: number;
  Year: number;
}